module.exports = __webpack_public_path__ + "static/media/edit.b4c12190.svg";